var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewspaperO(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 10.313,
    viewBox: "0 0 15 10.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "newspaper-o",
    className: "cls-1",
    d: "M7.5,2.813H4.687V5.625H7.5ZM8.437,7.5v.938H3.75V7.5Zm0-5.625V6.563H3.75V1.875ZM13.125,7.5v.938H9.375V7.5Zm0-1.875v.938H9.375V5.625Zm0-1.875v.938H9.375V3.75Zm0-1.875v.938H9.375V1.875ZM1.875,8.906V1.875H.937V8.906a.45.45,0,0,0,.139.33.46.46,0,0,0,.659,0A.45.45,0,0,0,1.875,8.906Zm12.187,0V.938H2.812V8.906a1.394,1.394,0,0,1-.08.469H13.594a.475.475,0,0,0,.469-.469ZM15,0V8.906a1.4,1.4,0,0,1-1.406,1.406H1.406a1.357,1.357,0,0,1-1-.41,1.354,1.354,0,0,1-.41-1V.938H1.875V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaperO);
export default __webpack_public_path__ + "static/media/newspaper-o.a99130e6c44408f3c6bce809e3f9fa25.svg";
export { ForwardRef as ReactComponent };